<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "NotificationSetting"
}
</script>

<style scoped>

</style>